module.exports = __webpack_public_path__ + "static/media/logo.2bb34a68.png";